import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface DatiConferma {
  titolo: string;
  testo?: string;
  /** Testo del pulsante che procede. Dillo con un verbo: "Elimina", non "OK". */
  conferma?: string;
  annulla?: string;
  /** Azione senza ritorno: il pulsante prende la forma di avvertimento. */
  distruttiva?: boolean;
}

@Component({
  standalone: true,
  selector: 'app-conferma-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './conferma-dialog.component.html',
})
export class ConfermaDialogComponent {
  readonly dati = inject<DatiConferma>(MAT_DIALOG_DATA);
  private readonly riferimento = inject(MatDialogRef<ConfermaDialogComponent, boolean>);

  chiudi(risposta: boolean): void {
    this.riferimento.close(risposta);
  }
}

/**
 * Conferme.
 *
 * Prima si usavano `confirm()` e `alert()` del browser: bloccano tutto, non si
 * possono vestire e su alcuni browser si possono zittire per sempre con una
 * casella di spunta, lasciando le eliminazioni senza rete.
 */
@Injectable({ providedIn: 'root' })
export class ConfermaService {
  private readonly dialog = inject(MatDialog);

  chiedi(dati: DatiConferma): Promise<boolean> {
    const riferimento = this.dialog.open<ConfermaDialogComponent, DatiConferma, boolean>(ConfermaDialogComponent, {
      data: dati,
      width: '420px',
      autoFocus: dati.distruttiva ? 'dialog' : 'first-tabbable',
    });

    return firstValueFrom(riferimento.afterClosed()).then((risposta) => risposta === true);
  }
}
